import React from "react";

const Folder = () => {
  return <span className="icon-icon_folder" />;
};

export default Folder;
